<template>
  <div id="notfall-styles">
    <div class="container pt-0">
      <div class="row">
        <div class="col">
          <zurueck-button
            class="position-absolute"
            style="bottom: 5px; left: 30px"
            @click="$store.commit('setPage', 'startseite')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="pane pane-outerpane">
            <div class="row">
              <div class="col-md-4">
                <div class="pane">
                  <div class="h1-like mt-4">
                    <font-awesome-icon icon="phone" />
                    {{ $t("telefon_notfall") }}
                  </div>
                  <br /><br />
                  <a :href="tellink" class="dark-btn w-100">{{
                    $t("btn_call")
                  }}</a>
                </div>
              </div>
              <div class="col-md-4">
                <div class="pane pane-inverted">
                  <div class="h1-like h1-like-large">
                    {{ $t("heading_emergency") }}
                  </div>
                  <br />
                  <div>
                    <span class="emerg" v-html="$t('text_emergency')"></span>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-md-6">
                      <font-awesome-icon icon="clock" />
                      {{ $t("text_emergency_duration") }}
                    </div>
                    <div class="col-md-6">
                      <font-awesome-icon icon="wallet" />
                      {{ $t("text_emergency_price") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="pane">
                  <div class="h1-like mt-4">
                    <font-awesome-icon icon="envelope" />
                    {{ $t("mail_notfall") }}
                  </div>
                  <br /><br />
                  <a :href="maillink" class="dark-btn w-100">{{
                    $t("btn_mail")
                  }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import Start from "@/components/Start.vue";

export default {
  name: "NotfallComponent",
  components: {
    //Start,
  },
  computed: {
    tellink() {
      return `tel:${this.$t("telefon_notfall").replaceAll(" ", "")}`;
    },
    maillink() {
      return `mailto:${encodeURIComponent(
        this.$t("mail_notfall").replaceAll(" ", "")
      )}`;
    },
  },
};
</script>
